import { history } from '../stores/index';
import qs from 'query-string';

export const getQueryParams = () => qs.parse(history.location.search);
